import { Component, Input, OnInit, TemplateRef, inject, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddApprovedLoanComponent } from 'src/app/AddThings/add-approved-loan/add-approved-loan.component';
import { AddContactComponent } from 'src/app/AddThings/add-contact/add-contact.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE, INJECT_TYPE } from 'src/app/constants';
import { CheckCustomerNecessaryFilesComponent } from 'src/app/Customer/check-customer-necessary-files/check-customer-necessary-files.component';
import { CustomerLoanCardComponent } from 'src/app/Customer/customer-loan-card/customer-loan-card.component';
import { EditEpfDetailsComponent } from 'src/app/Customer/edit-epf-details/edit-epf-details.component';
import { AccountAuthorizationListComponent } from 'src/app/Dashboards/account-authorization-list/account-authorization-list.component';
import { DialogItem } from 'src/app/dialog-item';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { ConflictedCustomerListComponent } from 'src/app/Others/conflicted-customer-list/conflicted-customer-list.component';
import { DeleteReasonComponent } from 'src/app/Others/delete-reason/delete-reason.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { DuitLebih } from 'src/model/duitLebih.model';
import { GlobalCustomer } from 'src/model/globalCustomer.model';
import { Loan } from 'src/model/loan.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { Profile } from 'src/model/profile.model';
import { ContactService } from 'src/services/contact.service';
import { CustomerService } from 'src/services/customer.service';
import { LoanRequestService } from 'src/services/loan-request.service';
import { LoanService } from 'src/services/loan.service';
import { AddLoanRequestGuarantorComponent } from '../add-loan-request-guarantor/add-loan-request-guarantor.component';
import { EditLoanRequestInfoComponent } from '../edit-loan-request-info/edit-loan-request-info.component';
import { EditLoanRequestRemarkComponent } from '../edit-loan-request-remark/edit-loan-request-remark.component';
import { BasicDialogComponent } from 'src/app/BaseDialog/basic-dialog/basic-dialog.component';

@Component({
    selector: 'app-loan-request-details',
    templateUrl: './loan-request-details.component.html',
    styleUrls: ['./loan-request-details.component.scss'],
    standalone: false
})
export class LoanRequestDetailsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private enums = inject(Enums);
  private router = inject(Router);
  private lrService = inject(LoanRequestService);
  private loanService = inject(LoanService);
  private customerService = inject(CustomerService);
  private contactService = inject(ContactService);

  @Input() data: any;
  @Input() request: LoanRequest;
  @Input() isExpanded = false;
  @Input() onlyViewLoan = false;

  @Input() viewOnly = false;
  @Input() editable = true;
  @Input() allowAction = false;
  @Input() showPrevious = true;
  @Input() includeShared = false;
  @Input() relatedCustomerIds: number[];

  @Input() isModal = false;
  previousSettlement = 0;
  previousSettlementRatio = 0;

  @Input() previousEPFLoanList: Loan[] = [];

  currentSettlementWithoutCharges: number;

  customerAuthorizations: AccountAuthorization[] = [];

  customerDetailsTemplate = viewChild.required<TemplateRef<any>>('customerDetails');

  async ngOnInit(): Promise<void> {
    if (this.data !== undefined) {
      this.request = this.data.request ?? undefined;
      this.onlyViewLoan = this.data.onlyViewLoan ?? undefined;
      this.editable = this.data.editable ?? undefined;
      this.viewOnly = this.data.viewOnly ?? undefined;
      this.isExpanded = this.data.isExpanded ?? undefined;
      this.onlyViewLoan = this.data.onlyViewLoan ?? undefined;
    }

    if (this.request != undefined) {
      if (this.showPrevious == true) {
        if (this.previousEPFLoanList.length == 0 || this.previousEPFLoanList == undefined) {
          this.getAllEPFLoans();
        }
        else {
          for (let i = 0; i < this.previousEPFLoanList.length; i++) {
            const settlementAmountWithoutCharge = this.previousEPFLoanList[i].Principal + (this.previousEPFLoanList[i].Term * this.previousEPFLoanList[i].Principal * (this.previousEPFLoanList[i].InterestRate / 100));

            if (this.previousEPFLoanList[i].Scheme == 'EPF') {
              if (this.previousEPFLoanList[i].SettlementCharges != undefined)
                this.previousSettlement += settlementAmountWithoutCharge + (this.previousEPFLoanList[i].SettlementCharges.Stamp) + (this.previousEPFLoanList[i].SettlementCharges.ServiceCharge) + (this.previousEPFLoanList[i].SettlementCharges.Extras);
              else
                this.previousSettlement += settlementAmountWithoutCharge + this.previousEPFLoanList[i].SettlementStamp + this.previousEPFLoanList[i].SettlementServiceCharge + this.previousEPFLoanList[i].SettlementExtra;
            }

            else
              this.previousSettlement += this.previousEPFLoanList[i].LegacySettlement;

            this.previousSettlementRatio = ((this.previousSettlement / this.request.EpfAmount) * 100);
          }
        }
      }

      if (this.sharedService.isBossAccount() || this.sharedService.isAdmin()) {
        this.request.ConflictedCustomerList = [];
        this.request.ConflictedGuarantorList = [];
        this.request.ConflictedTicketCustomerList = [];

        //check if ticket customer conflicted
        this.searchConflictedGuarantor(this.request.CustomerIC, -1);
        this.findConflictedCustomer(this.request.CustomerIC, -1);
        this.findConflictedTicketCustomer(this.request.CustomerIC, -1)

        //check if guarantor conflicted
        if (this.request.Guarantors != undefined && this.request.Guarantors.length > 0) {
          for (let i = 0; i < this.request.Guarantors.length; i++) {
            this.searchConflictedGuarantor(this.request.Guarantors[i].ICNumber, i);
            this.findConflictedCustomer(this.request.Guarantors[i].ICNumber, i);
            this.findConflictedTicketCustomer(this.request.Guarantors[i].ICNumber, i)
          }
        }

        // this.customerAuthorizations = await this.accountAuthorizationService.getAllAccountAuthorizations([this.request.CustomerId], undefined, true);
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  downloadGuarantorForm(contact: Contact) {
    const companyId = this.request.CompanyId;

    this.router.navigateByUrl('/guarantorForm/' + companyId + "/" + this.request.CustomerId + "/" + contact.ID);
  }

  async getAllEPFLoans() {
    const includedStatus = [this.enums.ACTIVE_LOAN, this.enums.WARNING_LOAN, this.enums.BAD_DEBT_LOAN];
    const loan = await this.loanService.getLoanOfCustomerProfile(this.request.ProfileId, { schemes: ["EPF"], status: includedStatus, withLegacyEPF: true, includedSharedProfile: this.includeShared });
    this.previousEPFLoanList = loan.filter(l => l.ID !== this.request.LoanID);
  }

  processGuarantorJsonArr(jsonArray: any) {
    const guarantorsInfo: Contact[] = [];
    jsonArray.forEach(json => {
      const guarantors = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark)
      guarantorsInfo.push(guarantors);
    });

    return guarantorsInfo;
  }

  processDuitLebihJsonArr(jsonArray: any) {
    const duitLebihList: DuitLebih[] = [];
    jsonArray.forEach(json => {
      const extra = new DuitLebih(json.amount, json.subtype)
      duitLebihList.push(extra);
    });

    return duitLebihList;
  }

  getTotalSettlement() {
    return this.sharedService.calculateEPFSettlementAmountWithCharges(this.request.LoanInfo) + this.sharedService.calculatePreviousEPFLoanSettlement(this.previousEPFLoanList);
  }

  getTotalSettlementRatio() {
    return (this.getTotalSettlement() / this.request.EpfAmount) * 100
  }

  goToCustomer() {
    this.router.navigate(['/manageCustomer', this.request.CustomerId, this.request.ProfileId]);
  }

  calculateTotalDuitLebih(request: LoanRequest) {
    let amount = 0;

    if (request.LoanInfo.Extras != undefined) {
      for (let i = 0; i < request.LoanInfo.Extras.length; i++) {
        amount += request.LoanInfo.Extras[i].Amount;
      }
    }

    return amount;
  }

  calculateTotalOnHand(request: LoanRequest) {
    let total = 0;

    if (request.LoanInfo != undefined) {
      const duitLebihTotal = this.calculateTotalDuitLebih(request);
      const processingCharge = (request.LoanInfo.ProcessingRate / 100) * request.LoanInfo.Principal;
      total += request.LoanInfo.Principal - request.LoanInfo.Reserve - duitLebihTotal - processingCharge - request.LoanInfo.StampAmount -
        request.LoanInfo.ServiceCharge
    }

    return total;
  }

  assessEPFCase() {
    let points = 0;
    if (this.request.Guarantors.length > 0)
      points++;

    if (this.request.LoanInfo != undefined && this.sharedService.roundToDec((this.request.LoanInfo.InterestRate), 4) >= 5)
      points++;

    if (this.request.LoanInfo != undefined) {
      if (this.getTotalSettlementRatio() < 25)
        points++;

      else
        points--;
    }
    return points;
  }

  confirmBeforeDeleteRequest(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to delete this loan request #" + request.ID;

    modalRef.result.then((confirm) => {
      if (confirm) {
        const modalRef = this.sharedService.openModal(DeleteReasonComponent);
        modalRef.componentInstance.passEntry.subscribe((entry) => {
          const remark = entry;

          //append added account to account list
          this.deleteLoanRequest(remark, request.ID);
        });
      }
    });
  }

  confirmBeforeDenial(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to DENY this loan request #" + request.ID;

    modalRef.result.then((confirm) => {
      if (confirm) {
        const modalRef = this.sharedService.openModal(DeleteReasonComponent);
        modalRef.componentInstance.type = "Denial";
        modalRef.componentInstance.passEntry.subscribe((entry) => {
          const remark = entry;

          //append added account to account list
          const processedRemark = (request.Remark) ? "DENIED: " + remark + "(" + request.Remark + ")" : "DENIED: " + remark;
          this.denyLoanRequest(processedRemark, request);
        });
      }
    });
  }

  deleteLoanRequest(remark: string, requestId: number) {
    const data =
    {
      "reason": remark
    };

    const xhr = this.restApi.deleteRequest(this.constructApi.getLoanApprovalRequestById(Number(requestId)), data);

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }

  denyLoanRequest(remark: string, request: LoanRequest) {
    const data = {
      "remark": remark
    };

    const xhr = (request.LoanGroupId == undefined)
      ? this.restApi.postRequest(this.constructApi.getDenyLoanApprovalRequest(request.ID), data)
      : this.restApi.postRequest(this.constructApi.getDenyGroupLoanApprovalRequest(request.LoanGroupId), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        window.location.reload();
      }
    }
  }

  openAddApprovedLoanModal(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(AddApprovedLoanComponent, 'largeModal');
    modalRef.componentInstance.approvedLoan = request.LoanInfo;
    modalRef.componentInstance.settlement = this.sharedService.calculateEPFSettlementAmount(request.LoanInfo.Principal, request.LoanInfo.InterestRate, request.LoanInfo.Term);
    const settlementWithCharges = this.sharedService.calculateEPFSettlementAmountWithCharges(request.LoanInfo);
    modalRef.componentInstance.settlementWithCharges = settlementWithCharges
    modalRef.componentInstance.ratio = this.sharedService.calculateSettlementRatio(settlementWithCharges, this.request.EpfAmount);
    modalRef.componentInstance.totalOnHand = this.calculateTotalOnHand(request);
    modalRef.componentInstance.approvedRequestId = request.ID;
    modalRef.componentInstance.selectedCustomerID = request.CustomerId;

    //check if this profile is a shared profile from other companies
    const isMainAccount = (this.request.SharedProfileId == this.request.ProfileId) || (this.request.SharedProfileId == undefined);

    modalRef.componentInstance.isMainAccount = isMainAccount;
  }

  async openShowWhatsappClipboardModal() {
    const requestList = await this.checkOtherLoanRequests();
    const modalRef = (this.sharedService.isAdmin() || this.sharedService.isBossAccount())
      ? this.sharedService.openModal(LoanRequestMessageComponent, "largeModal")
      : this.sharedService.openModal(LoanRequestMessageComponent);
    modalRef.componentInstance.requestList = requestList;
    modalRef.componentInstance.isEPFRequest = requestList[0].LoanInfo.Scheme == 'EPF';
    modalRef.componentInstance.loanGroupId = requestList[0].LoanGroupId;
    // modalRef.componentInstance.previousEPFLoanList = this.previousEPFLoanList;
  }

  async checkOtherLoanRequests(): Promise<LoanRequest[]> {
    let req: LoanRequest[] = [this.request];
    try {
      if (this.request.LoanGroupId != undefined)
        req = await this.lrService.getLoanGroupApprovalRequests(this.request.LoanGroupId);
      req.sort((a, b) => ((a.ID > b.ID)) ? -1 : 1);
    } finally {
      return req;
    }
  }

  async viewContactImages(contact: Contact) {
    const files = await this.contactService.getCustomerContactAllFiles(this.request.CustomerId, contact.ID);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
    i.showDelete = false;
  }

  openEditEPFModal() {
    const modalRef = this.sharedService.openModal(EditEpfDetailsComponent, 'largeModal');
    modalRef.componentInstance.dob = this.request.DOB;
    modalRef.componentInstance.customerId = this.request.CustomerId;
  }

  openEditGuaratorModal(contact: Contact) {
    const modalRef = this.sharedService.openModal(AddContactComponent, 'largeModal');
    modalRef.componentInstance.viewCustomerId = this.request.CustomerId;
    modalRef.componentInstance.contactToUpdate = contact;
  }

  openEditLoanInfoModal(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(EditLoanRequestInfoComponent, 'largeModal');
    modalRef.componentInstance.request = request;

    if (request.LoanInfo.Extras == undefined)
      request.LoanInfo.Extras = [];
    modalRef.componentInstance.settlementAmount = request.LoanInfo.Principal + (request.LoanInfo.Term *
      request.LoanInfo.Principal * (request.LoanInfo.InterestRate / 100));
  }

  openAddGuarantorModal(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(AddLoanRequestGuarantorComponent, 'largeModal');
    modalRef.componentInstance.request = request;
  }

  openEditLoanRequestRemarkModal(request: LoanRequest) {
    const modalRef = this.sharedService.openModal(EditLoanRequestRemarkComponent, 'largeModal');
    modalRef.componentInstance.request = request;
  }

  async viewCustomerImages(customerId: number) {
    const files = await this.customerService.getCustomerAllFiles(customerId);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
    i.injectContent = [new DialogItem(CheckCustomerNecessaryFilesComponent, { customerId: customerId })];
    i.imgViewerInjectContent = [new DialogItem(this.customerDetailsTemplate(), { name: this.request.CustomerName, ic: this.sharedService.processICNum(this.request.CustomerIC), dob: this.request.DOB }, INJECT_TYPE.TEMPLATE)];
  }

  searchConflictedGuarantor(ic: string, guarantorIndex: number) {
    if (guarantorIndex != -1)
      this.request.Guarantors[guarantorIndex].ConflictedGuarantorList = [];

    if (ic != undefined)
      var icNumberFormat = this.sharedService.sanitizeICNumInput(ic)
    const xhr = this.restApi.getRequest(this.constructApi.getSearchGuarantor(icNumberFormat, this.request.CustomerId.toString()));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          const jsonArray = JSON.parse((xhr.responseText));

          if (jsonArray.length > 0) {
            jsonArray.forEach(json => {
              let guarantor;
              // create customer instance with all response data

              guarantor = new GlobalCustomer(json.customerName, json.CustomerIcNumber, json.companyCode, json.customerId, undefined, undefined, undefined, undefined, undefined, json.name, json.icNumber);

              //add customer instance into customer list
              if (guarantorIndex != -1)
                this.request.Guarantors[guarantorIndex].ConflictedGuarantorList.push(guarantor);
              else
                this.request.ConflictedGuarantorList.push(guarantor);
            });
          }
        }
        else {
          if (guarantorIndex != -1)
            this.request.Guarantors[guarantorIndex].ConflictedGuarantorList = undefined;
          else
            this.request.ConflictedGuarantorList = undefined;
        }
      }
    }
  }

  async findConflictedTicketCustomer(ic: string, guarantorIndex: number) {
    if (guarantorIndex != -1)
      this.request.Guarantors[guarantorIndex].ConflictedTicketCustomerList = [];

    if (ic != undefined)
      var icNumberFormat = this.sharedService.sanitizeICNumInput(ic)

    const lrList = await this.lrService.findConflictedTicketCustomer({ icNumber: icNumberFormat, excludeCustomerId: this.request.CustomerId, approved: true, inclUnprocessed: true, withLoan: false });

    if (guarantorIndex != -1)
      this.request.Guarantors[guarantorIndex].ConflictedTicketCustomerList = lrList;
    else
      //conflicted ticket list only include those with diff loan group: which is not shared
      this.request.ConflictedTicketCustomerList = lrList.filter(lr => lr.LoanGroupId != this.request.LoanGroupId)
  }

  findConflictedCustomer(ic: string, guarantorIndex: number) {
    if (guarantorIndex != -1)
      this.request.Guarantors[guarantorIndex].ConflictedCustomerList = [];

    if (ic != undefined)
      var icNumberFormat = this.sharedService.sanitizeICNumInput(ic)
    let xhr;
    xhr = this.restApi.getRequest(this.constructApi.getGlobalSearch("", icNumberFormat));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          const jsonArray = JSON.parse((xhr.responseText));

          if (jsonArray.length > 0) {
            jsonArray.forEach(json => {
              const customer = new GlobalCustomer(json.name, json.icNumber, json.companyCode, json.id, json.status);
              //add customer instance into customer list
              if (guarantorIndex != -1)
                this.request.Guarantors[guarantorIndex].ConflictedCustomerList.push(customer);

              else if (this.request.CustomerId != customer.CustomerID && !this.relatedCustomerIds?.includes(customer.CustomerID)) {
                this.request.ConflictedCustomerList.push(customer);
              }
            });
          }
        }
        else {
          if (guarantorIndex != -1)
            this.request.Guarantors[guarantorIndex].ConflictedCustomerList = undefined;
          else
            this.request.ConflictedCustomerList = undefined;
        }
      }
    }
  }

  openConflictedModal(conflictedCustomerList: GlobalCustomer, conflictedGuarantorList: GlobalCustomer, conflictedTicketCustomerList: LoanRequest) {
    const modalRef = this.sharedService.openModal(ConflictedCustomerListComponent, "regularModal");
    modalRef.componentInstance.customerList = conflictedCustomerList;
    modalRef.componentInstance.guarantorList = conflictedGuarantorList;
    modalRef.componentInstance.ticketList = conflictedTicketCustomerList;
    // console.log(conflictedCustomerList)
  }

  viewCustomerProfileLoans(request: LoanRequest) {
    const customer = new Customer(request.CustomerId, request.CustomerName);
    customer.ICNumber = request.CustomerIC;
    const profile = new Profile(request.ProfileId);
    profile.CustomerID = request.CustomerId;
    const modalRef = this.sharedService.openModal(BasicDialogComponent, "largeModal");
    const i = modalRef.componentInstance as BasicDialogComponent;
    i.title = `Loan List - (${customer.Name} | ${customer.ICNumberWithDash})`;
    i.injectContent = [new DialogItem(CustomerLoanCardComponent, { viewCustomer: customer, selectedProfile: profile })];
  }

  openPendingAccountsModal(pendingAuthorizations: AccountAuthorization[]) {
    const modalRef = this.sharedService.openModal(AccountAuthorizationListComponent, "largeModal");
    modalRef.componentInstance.isModal = true;
    modalRef.componentInstance.pendingAuthorizations = pendingAuthorizations;
  }
}
